module.exports = __webpack_public_path__ + "media/mypage/images/icons/s_icon_syokusyu-ff06ff5e3e8f1bf5c4e8f54acb15904a.png";